import React, { Component } from 'react'

class Input extends Component {
  render() {
    return (
      <input type={this.props.type} onBlur={this.props.onBlur}  defaultValue={this.props.value} readOnly={this.props.readOnly} accept={this.props.accept} placeholder={this.props.placeholder} className={this.props.className} id={this.props.id} name={this.props.name} min={this.props.min} onChange={this.props.onChange} maxLength={this.props.maxLength} />
    )
  }
}
Input.defaultProps = {
  className: "form-control",
  name:"",
}
export default Input;



// WEBPACK FOOTER //
// ./src/shared/components/Input/index.js